import React, {
  useState,
  useMemo,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';

import clientInfoTabs from '../../CoachTools/components/ClientInfo/tabs';
import QAPContext, { initialValues } from './QAPContext';

const QAPContextProvider = ({
  children,
}) => {
  const [selectedUserId, setselectedUserId] = useState(initialValues.selectedUserId);
  const [selectedTab, setselectedTab] = useState(initialValues.selectedTab);
  // Which product the panel was opened for, so a feed card's choice carries into the
  // assign modal. Undefined on the full-page route.
  const [selectedProductId, setSelectedProductId] = useState(null);

  const openQAP = useCallback((userId, defaultTab = clientInfoTabs.NOTES, productId = null) => {
    setselectedUserId(userId);
    setselectedTab(defaultTab);
    setSelectedProductId(productId);
  }, []);

  const closeQAP = useCallback(() => {
    setselectedUserId(null);
    setSelectedProductId(null);
  }, []);

  // This provider outlives the panel, so the product is only valid for the client it was opened for.
  const productIdForUser = useCallback(
    (userId) => (userId && userId === selectedUserId ? selectedProductId : null),
    [selectedUserId, selectedProductId],
  );

  const contextValue = useMemo(() => ({
    isOpen: !!selectedUserId,
    openQAP,
    closeQAP,
    selectedUserId,
    selectedTab,
    productIdForUser,
  }), [
    selectedUserId,
    openQAP,
    closeQAP,
    selectedTab,
    productIdForUser,
  ]);

  return (
    <QAPContext.Provider value={contextValue}>
      {children}
    </QAPContext.Provider>
  );
};

QAPContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default QAPContextProvider;
